module.exports = __webpack_public_path__ + "static/img/product_banner01.3c4d287.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/ter/images/product_banner01.png
// module id = Jr7N
// module chunks = 0